// extracted by mini-css-extract-plugin
module.exports = {"invitationCard":"InvitationDateSection_invitationCard__24Yx9","eventName":"InvitationDateSection_eventName__3UId7","logo":"InvitationDateSection_logo__2691h"};